// HeroSection.jsx
import React from 'react';
import './LandingPage.css';

export default function HeroSection() {
  const ChatbotInterface = () => (
    <div className="chatbot-card">
      {/* Search Bar */}
      <div className="search-bar">
        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <span className="search-text">Explain this to me like I'm five</span>
        <span className="tag-pill">
          <svg className="tag-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c1.657 0 3 .895 3 2s-1.343 2-3 2-3-.895-3-2 1.343-2 3-2zM12 8V3M8 12H3M16 12h5M12 21v-5" />
          </svg>
          Singularities...
        </span>
      </div>

      {/* Response Area */}
      <div className="response-area">
        <div className="mock-link">
          <div className="link-thumbnail">
            <svg className="thumbnail-icon" fill="#1f2937" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
            </svg>
          </div>
          <div className="link-text">
            <p className="link-title">Singularities in S...</p>
            <p className="link-source">Quanta Magazine</p>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="controls-area">
        <span className="add-tabs">
          <svg className="control-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add tabs or files
        </span>
        <button className="upload-button">
          <svg className="upload-icon" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8.25 10.875L12 15L15.75 10.875H13.5V3H10.5V10.875H8.25ZM19.5 15V21H4.5V15H1.5V21C1.5 22.38 2.62 23.5 4 23.5H20C21.38 23.5 22.5 22.38 22.5 21V15H19.5Z" />
          </svg>
        </button>
      </div>
    </div>
  );

  return (
    <section className="hero-container">
      <h1 className="headline">The Complete AI Social Media Marketing & Lead Generation Platform</h1>
      <p className="subheading">AI agents that automate content, generate leads, and drive conversions-all from one platform</p>
      
      <a href="https://app.youform.com/forms/qw5x4urb" target="_blank" rel="noopener noreferrer" className="cta-button">
        Join Waitlist!
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </a>

      <ChatbotInterface />
    </section>
  );
}